import React, { FC } from 'react';

import { IButtonVerticalItem } from '../../../common/messageCreators';
import { ButtonsGrid } from '../ButtonsGrid';
import { ButtonsVerticalItem } from './ButtonsVerticalItem';

type ButtonsVerticalProps = {
  items: IButtonVerticalItem[];
  onClick: (btn: IButtonVerticalItem, position: number) => void;
};

export const ButtonsVertical: FC<ButtonsVerticalProps> = ({ items, onClick }) => {
  const buttons = items.map((item, i) => {
    return <ButtonsVerticalItem key={item._id} item={item} position={i} onClick={onClick} />;
  });

  return <ButtonsGrid>{buttons}</ButtonsGrid>;
};
